import { informationStyles as styles } from "@iewcasia/Overrides/Widgets/InvoiceDetails/InvoiceDetailsInformation";

styles.informationGridItem = {
    ...styles.informationGridItem,
    width: [12, 12, 6, 6, 6],
};

styles.informationGridContainer = {
    ...styles.informationGridContainer,
    gap: 0,
};

styles.invoiceDateGridItem = {
    ...styles.invoiceDateGridItem,
    width: 12,
};

styles.poNumberGridItem = {
    ...styles.poNumberGridItem,
    width: 12,
};

styles.statusGridItem = {
    ...styles.statusGridItem,
    width: 12,
};

styles.shippingMethodGridItem = {
    ...styles.shippingMethodGridItem,
    width: 12,
};

styles.termsGridItem = {
    ...styles.termsGridItem,
    width: 12,
};

styles.salespersonGridItem = {
    ...styles.salespersonGridItem,
    width: 12,
};

styles.dueDateGridItem = {
    ...styles.dueDateGridItem,
    width: 12,
};

styles.vatNumberGridItem = {
    ...styles.vatNumberGridItem,
    width: 12,
};

styles.shippingAddressGridItem = {
    ...styles.shippingAddressGridItem,
    width: 12,
};

styles.billingAddressGridItem = {
    ...styles.billingAddressGridItem,
    width: 12,
};

styles.invoiceNotesGridItem = {
    ...styles.invoiceNotesGridItem,
    width: 12,
};
